import Logger from "../../../core/internal/logger"
import { InAppMessageScheduleActionDeterminer } from "./action/InAppMessageScheduleActionDeterminer"
import { InAppMessageScheduleListener } from "./InAppMessageScheduleListener"
import { InAppMessageScheduleRequest } from "./InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "./InAppMessageScheduleResponse"
import { InAppMessageSchedulerFactory } from "./scheduler/InAppMessageSchedulerFactory"

export class InAppMessageScheduleProcessor implements InAppMessageScheduleListener {
  constructor(
    private readonly actionDeterminer: InAppMessageScheduleActionDeterminer,
    private readonly schedulerFactory: InAppMessageSchedulerFactory
  ) {}

  async process(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse> {
    Logger.log.debug(`InAppMessage Schedule Request: ${request}`)
    const response = await this.schedule(request)
    Logger.log.debug(`InAppMessage Schedule Response: ${response}`)
    return response
  }

  private async schedule(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse> {
    try {
      const action = this.actionDeterminer.determine(request)
      const scheduler = this.schedulerFactory.get(request.scheduleType)
      return await scheduler.schedule(action, request)
    } catch (e) {
      Logger.log.error(`Failed to process InAppMessageSchedule: ${e}`)
      return InAppMessageScheduleResponse.of(request, "EXCEPTION")
    }
  }

  onSchedule(request: InAppMessageScheduleRequest) {
    void this.process(request)
  }
}
